import { PitcherSingleSessionReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const PitcherSingleSessionPitchByPitchStatsChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PitcherSingleSessionPitchByPitchStatsChart'
      chartKey='pitcherSingleSessionPitchByPitchStatsChartConfig'
      {...props}
    />
  );
};

export default PitcherSingleSessionPitchByPitchStatsChartSidebar;
